import React from 'react';

import DataGrid from './DataGrid';
import { DataGridColDef } from './DataGrid/DataGrid';
import { PropElemScheduleResponse } from '../services/proposal';
import { toCurrency } from '../utils/utils';

export type ServiceScheduleTableProps = {
  financialSchedule: PropElemScheduleResponse[];
  currcode?: string;
  flagretailer?: boolean;
};

const ServiceScheduleTable = (props: ServiceScheduleTableProps) => {
  const { financialSchedule, currcode, flagretailer } = props;

  const COLUMNS: DataGridColDef<PropElemScheduleResponse>[] = [
    {
      comcode: 'PaymentSchedule.ctsorder',
      dataIndex: 'ctsorder',
      fixed: 'left',
      width: 80,
    },
    {
      comcode: 'PaymentSchedule.ctstype',
      dataIndex: 'ctstype',
      fixed: 'left',
      width: 100,
      // render: (val) =>
      //   flagretailer && val === 'RENTAL'
      //     ? 'GRACE'
      //     : flagretailer && val === 'RV'
      //     ? 'CAPITAL'
      //     : val,
    },
    {
      comcode: 'PaymentSchedule.ctsduedate',
      dataIndex: 'ctsduedate',
      fixed: 'left',
      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsstartamount',
      dataIndex: 'ctsstartamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),

      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsamortizedamount',
      dataIndex: 'ctsamortizedamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),

      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsoutstandingamount',
      dataIndex: 'ctsoutstandingamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),

      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsinterestamount',
      dataIndex: 'ctsinterestamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),

      width: 100,
    },
    {
      align: 'right',
      comcode: 'psTable.ctstaxamount',
      dataIndex: 'ctstaxamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),

      width: 100,
    },
    {
      comcode: 'PaymentSchedule.ctsstartdate',
      dataIndex: 'ctsstartdate',
      width: 100,
    },
    {
      comcode: 'PaymentSchedule.ctsenddate',
      dataIndex: 'ctsenddate',
      width: 100,
    },

    {
      comcode: 'ctsstatus',
      dataIndex: 'ctsstatus',
      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsrentalamount',
      dataIndex: 'ctsrentalamount',
      render: (val) =>
        toCurrency(val, currcode ?? localStorage.getItem('currcode') ?? ''),

      width: 100,
      fixed: 'right',
    },
  ];
  return (
    <DataGrid
      dataSource={financialSchedule}
      columns={COLUMNS}
      rowKey={(record) => record.ctsorder}
      scroll={{ x: 1000, y: 360 }}
      pagination={{ pageSize: 200 }}
    />
  );
};

export default ServiceScheduleTable;
